import type { FigureSource } from '@/api/advertisingOverview'
import type { AttributionModel } from '@/api/types'
import { TmtAttributedBadge } from '@/components/TmtAttributedBadge'
import { TooltipBadge } from '@/components/TooltipBadge'
import { SourceBadge } from '@/features/analytics/advertising/AdvertisingBadges'

import { ALL_SALES_CAVEAT } from './definitions'

/** Every completed order over Meta's spend: no attribution, so neither TmT's badge nor Meta's. */
export function AllSalesBadge() {
  return <TooltipBadge tone="neutral" label="All sales" tooltip={`${ALL_SALES_CAVEAT}.`} className="aov-all-sales-badge" />
}

/**
 * Whose number a KPI is: TmT's own first-party attribution under the selected model
 * (`TmtAttributedBadge`), reported by Meta (`SourceBadge`, the Ads page's), or every
 * sale over Meta's spend (`AllSalesBadge`). The two
 * never share a badge, and a figure of one is never added to a figure of the other.
 * Meta's own *attributed* purchases and revenue carry `ProviderAttributedBadge` instead.
 */
export function FigureSourceBadge({
  source,
  model,
  lookbackDays,
}: {
  source: FigureSource
  model: AttributionModel
  lookbackDays: number
}) {
  if (source === 'tmt') return <TmtAttributedBadge model={model} lookbackDays={lookbackDays} className="adv-tmt-badge" />
  if (source === 'all_sales') return <AllSalesBadge />
  return <SourceBadge />
}
